// Datos que aparecen en las páginas legales.
//
// Qué exige la ley y qué no (revisado el 28/10/2026):
// - RGPD art. 13.1.a: al tratar datos de usuarios registrados hay que indicar
//   la identidad del responsable y un contacto. Basta nombre y un email; el
//   email puede ser uno dedicado a la web (no hace falta el personal).
// - LSSI-CE art. 10 (NIF y domicilio): solo aplica si la web es una actividad
//   económica (publicidad, patrocinios, donaciones, afiliación, venta...).
//   Hoy Diegoncurso no lo es, así que no se publican. Si eso cambia, hay que
//   añadir NIF y domicilio al Aviso legal.
//
// Decisión del titular (28/10/2026): identificarse con su seudónimo público
// y el email de la web, sin nombre real. Es identificación incompleta según
// el art. 13 RGPD; riesgo asumido. Si la AEPD lo requiere, basta con poner
// aquí el nombre real y volver a publicar.
//
// Si cambian las Condiciones o la Política de privacidad de forma relevante,
// actualizar `ultimaActualizacion` y `versionTerminos`, y la misma versión en
// backend/models/UsuarioModel.php (TERMINOS_VERSION).
export const LEGAL = {
  nombreSitio: 'Diegoncurso',
  dominio: 'diegoncurso.es',
  titular: 'Don_Diegons',
  // Buzón dedicado a la web (no personal). Debe existir y revisarse: por aquí
  // llegan las peticiones de privacidad y las denuncias de contenido.
  email: 'diegoncurso@gmail.com',
  hosting: 'Arsys Internet, S.L.U.',
  edadMinima: 14,
  ultimaActualizacion: '29 de octubre de 2026',
  fechaISO: '2026-10-29',
  versionTerminos: '2026-10-29',
};

// Un dato está pendiente mientras siga siendo el texto de ejemplo entre corchetes.
export const esDatoPendiente = (valor) => /^\[.*\]$/.test(String(valor || '').trim());

export const LEGAL_PAGES = [
  { to: '/aviso-legal', label: 'Aviso legal' },
  { to: '/privacidad', label: 'Privacidad' },
  { to: '/cookies', label: 'Cookies' },
  { to: '/condiciones', label: 'Condiciones de uso' },
];
